import { createFileRoute } from "@tanstack/react-router";
import { StakingIdlePage } from "../../features/staking/pages/staking-idle-page";

export const Route = createFileRoute("/_layout/staking/idle")({
  component: StakingIdlePage,
});
